



























import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import OzButton from 'library/v4/components/oz-button.vue'
import { postColorTailwindClass } from 'bits/post_color'
import { Post } from 'types'

@Component({ components: { OzButton } })
export default class SurfacePostAttachmentButton extends Vue {
  @Prop() post!: Post
  @Prop() iconName!: 'play' | 'download'
  @Getter colorScheme!: 'light' | 'dark'

  get isLightColorScheme(): boolean {
    return this.colorScheme == 'light'
  }
  get postColorClass(): string {
    return postColorTailwindClass({ postColor: this.post.color, isLightColorScheme: this.isLightColorScheme })
  }

  get buttonColorClass(): string {
    switch (this.post.color) {
      case 'red':
        return this.isLightColorScheme ? 'bg-scarlet-200' : 'bg-scarlet-700'
      case 'orange':
        return this.isLightColorScheme ? 'bg-canary-200' : 'bg-tangerine-700'
      case 'green':
        return this.isLightColorScheme ? 'bg-park-200' : 'bg-park-700'
      case 'blue':
        return this.isLightColorScheme ? 'bg-oceanic-200' : 'bg-oceanic-700'
      case 'purple':
        return this.isLightColorScheme ? 'bg-grape-200' : 'bg-grape-700'
      default:
        return this.isLightColorScheme ? 'bg-light-ui-200' : 'bg-dark-ui-200'
    }
  }

  get buttonHoverColorClass(): string {
    switch (this.post.color) {
      case 'red':
        return this.isLightColorScheme ? 'hover-hover:hover:bg-scarlet-300' : 'hover-hover:hover:bg-scarlet-600'
      case 'orange':
        return this.isLightColorScheme ? 'hover-hover:hover:bg-canary-300' : 'hover-hover:hover:bg-tangerine-600'
      case 'green':
        return this.isLightColorScheme ? 'hover-hover:hover:bg-park-300' : 'hover-hover:hover:bg-park-600'
      case 'blue':
        return this.isLightColorScheme ? 'hover-hover:hover:bg-oceanic-300' : 'hover-hover:hover:bg-oceanic-600'
      case 'purple':
        return this.isLightColorScheme ? 'hover-hover:hover:bg-grape-300' : 'hover-hover:hover:bg-grape-600'
      default:
        return this.isLightColorScheme ? 'hover-hover:hover:bg-light-ui-300' : 'hover-hover:hover:bg-dark-ui-300'
    }
  }

  get buttonIconColorClass(): string {
    switch (this.post.color) {
      case 'red':
        return this.isLightColorScheme ? 'text-scarlet-600' : 'text-scarlet-200'
      case 'orange':
        return this.isLightColorScheme ? 'text-canary-600' : 'text-tangerine-200'
      case 'green':
        return this.isLightColorScheme ? 'text-park-600' : 'text-park-200'
      case 'blue':
        return this.isLightColorScheme ? 'text-oceanic-600' : 'text-oceanic-200'
      case 'purple':
        return this.isLightColorScheme ? 'text-grape-600' : 'text-grape-200'
      default:
        return this.isLightColorScheme ? 'text-dark-text-200' : 'text-light-text-200'
    }
  }
}
